import React from 'react'
import { connect } from 'react-redux'
import OpenGameModal from '../components/open-game-modal'

const mapStateToProps = (state) => ({
  ...state.openGameModal
})

const mapDispatchToProps = dispatch => ({
  loadGame: payload => dispatch({type: 'OPEN_GAME_MODAL.LOAD_GAME', payload}),
  clearGame: payload => dispatch({type: 'OPEN_GAME_MODAL.CLEAR_GAME', payload}),
  roasterChanged: payload => dispatch({type: 'OPEN_GAME_MODAL.ROASTER_CHANGED', payload}),
  showAlert: payload => dispatch({type: 'OPEN_GAME_MODAL.SHOW_ALERT', payload}),
  clearAlert: payload => dispatch({type: 'OPEN_GAME_MODAL.CLEAR_ALERT', payload}),
  onChangeGuests: payload => dispatch({type: 'OPEN_GAME_MODAL.CHANGE_GUESTS', payload}),
  onUpdatePR: payload => dispatch({type: 'OPEN_GAME_MODAL.UPDATE_PR', payload}),
  onEditCost: payload => dispatch({type: 'OPEN_GAME_MODAL.EDIT_COST', payload}),
  onAddPlayer: payload => dispatch({type: 'OPEN_GAME_MODAL.ADD_PLAYER', payload}),
  onRemovePlayer: payload => dispatch({type: 'OPEN_GAME_MODAL.REMOVE_PLAYER', payload}),
  onCreateNote: payload => dispatch({type: 'OPEN_GAME_MODAL.CREATE_NOTE', payload}),
  onEditNote: payload => dispatch({type: 'OPEN_GAME_MODAL.EDIT_NOTE', payload}),
  onRemoveNote: payload => dispatch({type: 'OPEN_GAME_MODAL.REMOVE_NOTE', payload}),
  onProcessAll: payload => dispatch({type: 'OPEN_GAME_MODAL.PROCESS_ALL', payload}),
  onCaptureAll: payload => dispatch({type: 'OPEN_GAME_MODAL.CAPTURE_ALL', payload}),
  updateGame: payload => dispatch({type: 'OPEN_GAME_MODAL.UPDATE_GAME', payload}),
  onConfirm: payload => dispatch({type: 'OPEN_GAME_MODAL.CONFIRM_GAME', payload}),
  onUpdatePlayer: payload => dispatch({type: 'OPEN_GAME_MODAL.UPDATE_PLAYER', payload}),
  onStartPayment: payload => dispatch({type: 'OPEN_GAME_MODAL.START_PAYMENT', payload}),
  onClearPayment: payload => dispatch({type: 'OPEN_GAME_MODAL.CLEAR_PAYMENT', payload}),
  onAddFake: payload => dispatch({type: 'OPEN_GAME_MODAL.ADD_FAKE', payload}),
  onSetRefreshFunc: payload => dispatch({type: 'OPEN_GAME_MODAL.SET_REFRESH_FUNC', payload}),
  readMessages: payload => dispatch({type: 'FIRESTORE_CHANNEL.MAKE_SEEN', payload}),
  onGamePaymentSuccess: payload => dispatch({type: 'PROCESS_ALL_PAYMENTS', payload}),
  onCreateChannel: payload => dispatch({type: 'OPEN_GAME_MODAL.CREATE_FIRESTORE_CHANNEL', payload}),
  onLoadEvents: payload => dispatch({type: 'OPEN_GAME_MODAL.LOAD_EVENTS', payload}),
  onLoadNotes: payload => dispatch({type: 'OPEN_GAME_MODAL.LOAD_NOTES', payload}),
  onLoadReviews: payload => dispatch({type: 'OPEN_GAME_MODAL.LOAD_REVIEWS', payload}),
  onLoadDrops: payload => dispatch({type: 'OPEN_GAME_MODAL.LOAD_DROPS', payload}),
  setGameDetailsLoading: payload => dispatch({type: 'OPEN_GAME_MODAL.SET_GAME_DETAILS_LOADING', payload}),
  onSetWaitingPlayers: payload => dispatch({type: 'OPEN_GAME_MODAL.SET_WAITING_PLAYERS', payload}),
  onCreateWaitingPlayer: payload => dispatch({type: 'OPEN_GAME_MODAL.CREATE_WAITING_PLAYER', payload}),
  onRemoveWaitingPlayer: payload => dispatch({type: 'OPEN_GAME_MODAL.REMOVE_WAITING_PLAYER', payload}),
  onSplitDrop: payload => dispatch({type: 'OPEN_GAME_MODAL.SPLIT_DROP', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(OpenGameModal)
